module.exports = {
      id: "ios-small-usage",
      viewBox: "0 0 448 512",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#ios-small",
      toString: function () {
        return this.url;
      }
    }